import i18n from '@quizzach/i18n';

export function copiesSoldText(number: number) {
	let form;

	const mod100 = number % 100;
	const mod10 = number % 10;

	if (mod100 >= 11 && mod100 <= 14) {
		form = i18n.t('common.wording.copiesSoldMany');
	} else if (mod10 === 1) {
		form = i18n.t('common.wording.copiesSoldOne');
	} else if (mod10 >= 2 && mod10 <= 4) {
		form = i18n.t('common.wording.copiesSoldFew');
	} else {
		form = i18n.t('common.wording.copiesSoldMany');
	}

	return `${form}`;
}
